export const projectRoutes = {
  edit: "edit",
  styling: "styling",
  plusButtonOptions: "plus-button",
  integrations: "integrations",
} as const;
